import React, { useState, useEffect } from 'react';
import { Plus, Edit, Trash2 } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DepartmentManagement = ({ user }) => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [newDepartment, setNewDepartment] = useState('');

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/departments`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setDepartments(response.data);
    } catch (error) {
      toast.error('Failed to fetch departments');
    } finally {
      setLoading(false);
    }
  };

  const handleAddDepartment = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        `${API_URL}/departments`,
        { name: newDepartment },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Department added successfully');
      setNewDepartment('');
      setShowModal(false);
      fetchDepartments();
    } catch (error) {
      toast.error('Failed to add department');
    }
  };

  const handleDelete = async (deptId) => {
    if (!window.confirm('Are you sure you want to delete this department?')) return;
    
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/departments/${deptId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Department deleted successfully');
      fetchDepartments();
    } catch (error) {
      toast.error('Failed to delete department');
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="management-page" data-testid="department-management">
      <div className="page-header">
        <h2>Department Management</h2>
        <button className="gradient-btn" onClick={() => setShowModal(true)} data-testid="add-department-btn">
          Add Department
        </button>
      </div>

      <div className="content-grid">
        {departments.map((dept) => (
          <div className="item-card card" key={dept.id} data-testid={`department-card-${dept.id}`}>
            <div className="item-header">
              <h3>{dept.name}</h3>
              <button className="delete-btn" onClick={() => handleDelete(dept.id)} data-testid={`delete-dept-${dept.id}`}>
                <Trash2 size={18} />
              </button>
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="modal-overlay" data-testid="department-modal">
          <div className="modal-content">
            <h3>Add New Department</h3>
            <form onSubmit={handleAddDepartment}>
              <input
                type="text"
                value={newDepartment}
                onChange={(e) => setNewDepartment(e.target.value)}
                placeholder="Department name"
                required
                data-testid="department-name-input"
              />
              <div className="modal-actions">
                <button type="button" onClick={() => setShowModal(false)} data-testid="cancel-dept-btn">Cancel</button>
                <button type="submit" className="gradient-btn" data-testid="submit-dept-btn">Add</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default DepartmentManagement;